const _ = require('lodash');

const defaultState = {
    inboxInstructions: [],
    loading: false,
    errors:{} 
}
  
  export default (state=defaultState, action={}) => {
    switch (action.type) {

      case 'FETCH_INBOX_INSTRUCTIONS_FULFILLED': {
 
        return {
          ...state,
          inboxInstructions: action.payload.data,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_INBOX_INSTRUCTIONS_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_INBOX_INSTRUCTIONS_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }

      case 'ADD_INSTRUCTIONS_FULFILLED': {
        
        let mergedInstructions = [...state.inboxInstructions, ...action.newInstructions];
        let orderedInstructions = _.orderBy(mergedInstructions, ['ID','CHANGE_DATETIME','BEGIN_DATE','BEGIN_TIME','ORDER_PHO'], ['desc','desc', 'asc', 'asc', 'asc']);

        return {
            ...state,
            inboxInstructions: orderedInstructions
        }         
      }

      case 'VALIDATE_INSTRUCTION_FULFILLED': {
        const id = action.instructionId;

        return {
            ...state,
            inboxInstructions: state.inboxInstructions.filter(item => item.ID !== id)
        }
      }

      case 'SEE_INSTRUCTION_FULFILLED': {
        const id = action.instructionId;
        let status = 'ACEITE';

        return {
            ...state,
            inboxInstructions: state.inboxInstructions.map(item => item.ID === id ?  {...item, STATUS: status} : item)
        }
      }

      case 'REJECT_INSTRUCTION_FULFILLED': {
        const id = action.instructionId;
        let status = 'RECLAMADA';

        return {
            ...state,
            inboxInstructions: state.inboxInstructions.map(item => item.ID === id ?  {...item, STATUS: status} : item)
        }
      }
      
      case 'CANCEL_INSTRUCTION_FULFILLED': {
        const id = action.instructionId;
        const status = 'CANCELADA';

        return {
            ...state,
            inboxInstructions: state.inboxInstructions.map(item => item.ID === id ?  {...item, STATUS: status} : item)
        }
      }

      case 'BAN_INSTRUCTION_FULFILLED': {
        const id = action.instructionId;
        const comments = action.comments;
        const status = 'ACEITE';
        return {
            ...state,
            inboxInstructions: state.inboxInstructions.map(item => item.ID === id ? {...item, STATUS: status , COMMENTS_EDPP: comments} : item)
        }
      }

      case 'EDIT_INSTRUCTION_FULFILLED': {
        const id = action.instruction.ID;
        const newItem = action.instruction;
        let finalList = [];

        // Step 1. Remove previous previous version of ID
        // Step 2. Add new version
        state.inboxInstructions.forEach(element => {

          if (element.ID === id ) {
            finalList.push(newItem);
          }
          else {
            finalList.push(element);
          }
          
        });

        return {
          ...state,
          inboxInstructions: finalList
        }        
      }

      case 'SETUPALARM_INSTRUCTION_FULFILLED': {
        const id = action.instruction.ID;
        const newItem = action.instruction;
        let finalList = [];

        // Step 1. Remove previous previous version of ID
        // Step 2. Add new version
        state.inboxInstructions.forEach(element => {

          if (element.ID === id ) {
            finalList.push(newItem);
          }
          else {
            finalList.push(element);
          }
          
        });

        return {
          ...state,
          inboxInstructions: finalList
        }        
      }

      case 'REMOVE_CANCELED_ID': {
        const id = action.id;

        return {
            ...state,
            inboxInstructions: state.inboxInstructions.filter(item => item.ID !== id)
        }
      }
      
      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/production-hidro-reducer.js